export const FIELD_COLUMN_WIDTH = 200;
export const DRAG_COLUMN_WIDTH = 40;
export const ACTION_COLUMN_WIDTH = 70;
